export const UserStatus = {
  PENDING: 'PENDING',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};
